// the breakpoint for non-mobile screens
const mediaQuery = '(min-width: 1220px)';

// breakpoint for large screens
const mediaQueryLg = '(min-width: 1020px)';

// Whether or not the defined media query has been met
export const isMobile = !window.matchMedia(`${mediaQuery}`).matches; // eslint-disable-line import/prefer-default-export
export const isLarge = window.matchMedia(`${mediaQueryLg}`).matches; // eslint-disable-line import/prefer-default-export



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/shared/utils/breakpoint.js